export default function() {

	//本番用
	let gmap_api_url = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCpeJtKD51InHPNDlP99jag_LPxNAnieZM&region=JP";

	//ローカル用
	// let gmap_api_url = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBwYJ5r8Ifrz7AIhmseQPBDGtMLOISn3Yc&region=JP";

	loadjs([gmap_api_url], {
			async: false
	});

}
